import React from "react";

const formatAmount = (value) =>
  new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(Number(value) || 0));

const formatQty = (value) =>
  new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 4,
  }).format(Number(value) || 0);

const InventorySummaryView = ({
  data = [],
  loading,
  error,
}) => {
  if (loading) {
    return (
      <div className="dd-loading">
        Loading inventory...
      </div>
    );
  }

  if (error) {
    return (
      <div className="dd-error">
        {error}
      </div>
    );
  }

  const rows = data.filter(item =>
    Number(item.openingQuantity) !== 0 ||
    Math.abs(Number(item.openingValue)) > 0
  );

  const totalValue = rows.reduce(
    (sum, item) =>
      sum + Math.abs(Number(item.openingValue) || 0),
    0
  );

  return (
    <div className="voucher-table-wrap">

      <table className="voucher-table">

        <thead>
          <tr>
            <th>Stock Item</th>
            <th>Unit</th>
            <th className="vt-amount-col">
              Opening Qty
            </th>
            <th className="vt-amount-col">
              Opening Value
            </th>
          </tr>
        </thead>

        <tbody>

          {rows.map(item => (
            <tr key={item.id}>

              <td className="vt-party">
                {item.StockItem?.name || "-"}
              </td>

              <td>
                {item.StockItem?.unit || "-"}
              </td>

              <td className="vt-amount">
                {formatQty(item.openingQuantity)}
              </td>

              <td className="vt-amount vt-out">
                {formatAmount(item.openingValue)}
              </td>

            </tr>
          ))}

        </tbody>

        <tfoot>

          <tr>

            <td
              colSpan={3}
              className="tb-total-label"
            >
              Total Opening Stock
            </td>

            <td className="vt-amount tb-total-value">
              {formatAmount(totalValue)}
            </td>

          </tr>

        </tfoot>

      </table>

    </div>
  );
};

export default InventorySummaryView;